import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { Flame, X } from "lucide-react";

export default function PotHypeBanner() {
  const [ev, setEv] = useState(null);
  const [hidden, setHidden] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    api.get("/cardwars/event").then(({ data }) => {
      setEv(data);
      setHidden(localStorage.getItem(`pot-hype-dismissed-${data.week_key}`) === "1");
    }).catch(() => {});
  }, []);
  const [, tick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => tick((n) => n + 1), 60000);
    return () => clearInterval(t);
  }, []);
  if (!ev || hidden || location.pathname === "/card-wars") return null;
  const ms = new Date(ev.resolves_at) - Date.now();
  const d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000), m = Math.floor((ms % 3600000) / 60000);
  const left = ms <= 0 ? "resolving now" : d > 0 ? `${d}d ${h}h` : h > 0 ? `${h}h ${m}m` : `${m}m`;
  const dismiss = (e) => {
    e.stopPropagation();
    localStorage.setItem(`pot-hype-dismissed-${ev.week_key}`, "1");
    setHidden(true);
  };
  return (
    <div data-testid="pot-hype-banner" onClick={() => navigate("/card-wars#friday")} role="button"
      className="relative z-10 mb-4 flex items-center gap-2 sm:gap-3 border border-pb-red/60 bg-gradient-to-r from-red-950/60 via-black to-red-950/40 px-3 sm:px-4 py-2 cursor-pointer hover:border-pb-red transition-colors overflow-hidden">
      <span className="relative flex h-2.5 w-2.5 shrink-0">
        <span className="animate-ping absolute inline-flex h-full w-full bg-pb-red opacity-75" />
        <span className="relative inline-flex h-2.5 w-2.5 bg-pb-red" />
      </span>
      <Flame className="w-4 h-4 text-pb-red shrink-0 animate-pulse" />
      <span className="flex flex-wrap items-baseline gap-x-2 min-w-0 text-[10px] sm:text-[11px] font-black uppercase tracking-widest">
        <span className="text-pb-red">Friday Night Bullpen Battle</span>
        <span className="text-yellow-400 font-mono animate-pulse" data-testid="pot-hype-pot">{ev.pot} BLC pot</span>
        <span className="text-zinc-400 hidden sm:inline">· {ev.entrants} in the pool</span>
        <span className="text-zinc-500">· resolves in {left}</span>
      </span>
      <span data-testid="pot-hype-cta"
        className="ml-auto shrink-0 text-[9px] font-black uppercase tracking-widest text-black bg-pb-red px-2.5 py-1 hidden sm:block">
        {ev.entered ? "You're In" : "Register Now"}
      </span>
      <button data-testid="pot-hype-close" onClick={dismiss} title="Hide until next week's battle"
        className="shrink-0 text-zinc-500 hover:text-white transition-colors">
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
